import React from 'react';
import MuiFormLabel, {type FormLabelProps as MuiFormLabelProps} from '@mui/material/FormLabel';

export type FormLabelProps = Pick<MuiFormLabelProps, 'children' | 'disabled' | 'required' | 'htmlFor' | 'id'>;

export const FormLabel: React.FC<FormLabelProps> = props => <MuiFormLabel {...props} error={false} focused={false} />;
